import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default function Listblock() {
  Alpine.data("listblock", () => ({
    init() {
      console.log("listblock init");

      var listAnimaiton = null;

      if (this.$refs.header) {
        gsap.to(this.$refs.header, {
          opacity: 0,
          scrollTrigger: {
            trigger: this.$refs.header,
            start: "top top",
            end: "+=100svh",
            scrub: true,
          },
        });
      }

      if (this.$refs.wrapper) {
        gsap.fromTo(
          this.$refs.wrapper,
          {
            opacity: 1,
          },
          {
            opacity: 0,
            scrollTrigger: {
              trigger: this.$refs.wrapper,
              start: "bottom bottom",
              end: "bottom center",
              scrub: true,
            },
          },
        );
      }

      if (this.$refs.wrapper) {
        gsap.fromTo(
          this.$refs.wrapper,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            scrollTrigger: {
              trigger: this.$refs.wrapper,
              start: "top center",
              end: "top top",
              scrub: true,
            },
          },
        );
      }

      if (
        this.$refs.list &&
        this.$refs.wrapper &&
        this.$refs.list.children &&
        this.$refs.list.children.length > 0
      ) {
        listAnimaiton = gsap.fromTo(
          this.$refs.list,
          {
            x: () =>
              window.innerWidth / 2 -
              this.$refs.list.children[0].offsetWidth * 0.5,
          },
          {
            ease: "none",
            x: () => {
              const listWidth = this.$refs.list.scrollWidth;
              const wrapperWidth = this.$refs.wrapper.offsetWidth;
              return (
                -(listWidth - wrapperWidth) -
                window.innerWidth * 0.5 +
                this.$refs.list.children[0].offsetWidth * 0.5
              );
            },
            scrollTrigger: {
              trigger: this.$refs.wrapper,
              start: "top top",
              end: "bottom bottom",
              scrub: true,
              invalidateOnRefresh: true,
              // pin: true,
            },
          },
        );
      }

      if (this.$refs.list && this.$refs.list.children.length > 0) {
        Array.from(this.$refs.list.children).map((child) => {
          const textElement = child.querySelector("[data-text]");
          gsap.fromTo(
            child,
            {
              scale: 0.8,
              // x: 160,

              opacity: 0,
            },
            {
              scale: 1,
              // x: 0,
              // transformOrigin: "left center",

              opacity: 1,
              ease: "none",
              scrollTrigger: {
                trigger: child,

                containerAnimation: listAnimaiton,
                // horizontal: true,
                // scroller: this.$refs.list,
                horizontal: true,
                scrub: true,
                start: "left right",
                end: "center center",
                onUpdate: (self) => {
                  const textProgress = gsap.utils.clamp(
                    0,
                    1,
                    gsap.utils.mapRange(0.6, 1, 0, 1, self.progress),
                  );
                  gsap.set(textElement, { opacity: textProgress });
                  gsap.set(textElement, { y: 20 - 20 * textProgress });
                },
              },
            },
          );
        });
      }
    },
  }));
}
